import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import './FacebookFeed.scss';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";
import UrlPart from "../../../../ConfigParameters/ConfigParameters/UrlPart";
import Language from "../../../../ConfigParameters/ConfigParameters/Language";
import Timeline from "../../../../ConfigParameters/ConfigParameters/Timeline";
import Events from "../../../../ConfigParameters/ConfigParameters/Events";
import Messages from "../../../../ConfigParameters/ConfigParameters/Messages";
import ShowUsers from "../../../../ConfigParameters/ConfigParameters/ShowUsers";
import contentGuardService from "../../../../Workspace/ContentGuard/ContentGuardService";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";
import TwitterWidth from "../../../../ConfigParameters/ConfigParameters/TwitterWidth";
import Height from "../../../../ConfigParameters/ConfigParameters/Height";

const MODULE_NAME = 'pageFacebookFeed';

const creatorPageSectionFacebookFeed = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./facebookFeed.html'),
    controller: function (ToolbarService, ContentGuardService, $scope) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));

            ContentGuardService.registerLocked(MODULE_NAME);
            FB.init({
                status: true,
                xfbml: true,
                version: 'v3.2'
            });
            FB.XFBML.parse();
        };

        $scope.$on('$destroy', () => {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });

        let debounce;
        $scope.$watchCollection('$ctrl.elementModel', (newParameters, oldParameters) => {
            if (newParameters['customClassName'] === oldParameters['customClassName']
                && newParameters['language'] === oldParameters['language']
                && newParameters['align'] === oldParameters['align']) {
                reloadFacebook();
            }
        });

        $scope.$watchCollection('$ctrl.elementModel.width', () => {
            reloadFacebook();
        });
        $scope.$watchCollection('$ctrl.elementModel.height', () => {
            reloadFacebook();
        });

        let reloadFacebook = () => {
            clearTimeout(debounce);
            debounce = setTimeout(() => {
                FB.XFBML.parse()
            }, 500);
        }
    }
};

export default angular.module('cms.creator.page.section-facebook-feed', [sectionsLibraryService, toolbarService, contentGuardService])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'face',
            type: MODULE_NAME,
            label: gettext('Facebook Feed'),
            group: 'page',
            options: {
                disableCopy: true
            },
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new UrlPart()),
            ...(new Language()),
            ...(new TwitterWidth()),
            ...(new Height()),
            ...(new Paddings()),
            ...(new Align()),
            ...(new CustomClassName()),
            ...(new Timeline()),
            ...(new Events()),
            ...(new Messages()),
            ...(new ShowUsers())
        });

    })
    .component('cmsCreatorPageSectionFacebookFeed', creatorPageSectionFacebookFeed).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/FacebookFeed/FacebookFeed.js